import { Mail } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import { GRACKLE_COLORS } from '@/lib/theme'
import type { AccountEngagement } from '@/types'
import { emailOnlyText } from './emailOnlyText'

/**
 * Shown on an account whose only activity in the last 6 months is the odd email
 * (dealActivity.js accountEngagementCtes). Renders nothing otherwise. The explanation is
 * visible text next to the badge, not a tooltip, so it reaches keyboard and screen-reader
 * users, and the state is carried by the word "Email only", not by colour.
 */
export function EmailOnlyNotice({ engagement }: { engagement?: AccountEngagement }) {
  if (!engagement?.email_only) return null
  return (
    <div className="flex flex-wrap items-center gap-2 mt-2 text-sm" role="note">
      <Badge
        variant="default"
        style={{
          backgroundColor: GRACKLE_COLORS.pollen,
          color: GRACKLE_COLORS.prussianBlue,
        }}
      >
        <Mail className="h-3 w-3 mr-1" aria-hidden="true" />
        Email only
      </Badge>
      <span className="text-muted-foreground">{emailOnlyText(engagement)}</span>
    </div>
  )
}
